import { format } from 'date-fns-tz';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    addUnitsOfTime,
    autoinject,
    bind, DateRangePicker,
    Enums, FormStore,
    inject,
    NothingHere, SubTopBar,
    subUnitsOfTime,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../../Core/AppStore';
import { DisplaysStore } from '../DisplaysStore';
import {Form} from "reactstrap";

export interface IDisplayEventStatusChangeLogParams {
    serialNumber: string;
}
export interface IDisplayEventStatusChangeLogProps extends RouteComponentProps<IDisplayEventStatusChangeLogParams> {}

@autoinject
@observer
export class DisplayEventStatusChangeLog extends React.Component<IDisplayEventStatusChangeLogProps, any> {
    public constructor(props: IDisplayEventStatusChangeLogProps) {
        super(props);
        this.state = {};

        const endTime = new Date();
        const startTime = subUnitsOfTime(new Date(), 1, 'day');

        this.formStore.fields.startTime.setValue(startTime);
        this.formStore.fields.endTime.setValue(endTime);
    }
    
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.displaysStore.loadAsync(this.props.match.params.serialNumber);
            await this.getEventLogAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div>
                <SubTopBar>
                    <Form onSubmit={this.onSubmit}>
                        <div className="d-block w-100">
                            <DateRangePicker
                                startDate={this.formStore.fields.startTime}
                                endDate={this.formStore.fields.endTime}
                                className="d-inline-block me-2"
                                timezone={this.displaysStore.timezones.get(this.props.match.params.serialNumber)}
                            />

                            <button className="mx-2 btn btn-primary">{this.loading ? 'Loading...' : 'Apply'}</button>
                        </div>
                    </Form>
                </SubTopBar>
                <div>
                    <table className="table table-sm">
                        <thead>
                        <tr>
                            <th scope="col">Event</th>
                            <th scope="col">Email</th>
                            <th scope="col">Profile</th>
                            <th scope="col">Updated Event Status</th>
                            <th scope="col">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.eventStatusChangeLogs?.map(this.renderAuditLog)}
                        </tbody>
                    </table>

                    <NothingHere loading={this.loading} empty={!this.eventStatusChangeLogs?.length} icon={<BsCardHeading />} />
                </div>
            </div>
        );
    }
    
    public renderAuditLog(auditLog: Mri.Audit.AuditLog<any>, key: any) {
        const log = auditLog.payload as Mri.Audit.EventStatusChangeLog;
        const url = log.profileGuid ? '/display-event-profiles/automations/' + log.profileGuid + '/edit' : undefined;
        
        return (
            <tr key={key}>
                <td scope="row">{log.eventDetails}</td>
                <td scope="row">{log.email}</td>
                <td scope="row">
                    {url && log.profileName != "Quick Clear" &&
                        <a href={url} target="_blank" className="p-0 btn btn-link">
                            {log.profileName}
                        </a>
                    }
                    {url && log.profileName == "Quick Clear" &&
                        <span>
                            {log.profileName}
                        </span>
                    }
                </td>
                <td scope="row">{Enums.toString(Enums.DisplayEventStatus, log.eventStatus)}</td>
                <td>{format(auditLog.timestamp, 'Pp z')}</td>
            </tr>
        );
    }

    @bind
    private onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        this.getEventLogAsync();
    }

    @bind
    @action
    private async getEventLogAsync() {
        this.loading = true;
        let startTime = new Date(this.formStore.fields.startTime.value);
        let endTime = new Date(this.formStore.fields.endTime.value);
        let oneYearAgo =  subUnitsOfTime(new Date(), 1, 'years');
        let dayInFuture = addUnitsOfTime(new Date(), 1, 'day');

        if(startTime < oneYearAgo) startTime = subUnitsOfTime(new Date(), 1, 'day');
        if(endTime > dayInFuture) endTime = new Date();

        try {
            await this.displaysStore.loadEventStatusChangeLogsAsync(
                this.props.match.params.serialNumber,
                startTime,
                endTime
            );
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    @computed
    private get eventStatusChangeLogs() {
        const logs = this.displaysStore.eventStatusChangeLogs.get(this.props.match.params.serialNumber);
        if (logs != undefined) {
            return logs.sort((a, b) => +new Date(b.timestamp) - +new Date(a.timestamp));
        }
        return logs;
    }

    private formStore = new FormStore({
        startTime: new Date(),
        endTime: new Date(),
    });
    @observable
    private loading = false;
    @inject
    private appStore!: AppStore;
    @inject
    private displaysStore!: DisplaysStore;
}
